module.exports = __webpack_public_path__ + "img/complete.d2292b31.png";